export const NO_SPECIAL_SYMBOLS_REGEX = /^[A-z\s-'.,]*$/;
